// extracted by mini-css-extract-plugin
export var btn = "x_mD v_rS v_rv d_bw d_bL d_bz d_ds";
export var full = "x_sk d_s d_D";